export class RouterConstants {
  static DEFAULT_ROUTER_OF_MASTER_OR_CLIENT = "EventList";
  static DEFAULT_ROUTER_OF_SHOP_OR_GROUP = "ShopEventDashboardParent";
}
